import React, { useEffect, useState } from 'react';
import api, { getApiBase, ficApi } from '../services/api';

// ── Ordinamento colonne ─────────────────────────────────────
function sortData(data, col, dir) {
  return [...(data||[])].sort((a, b) => {
    let va = a[col] != null ? a[col] : '';
    let vb = b[col] != null ? b[col] : '';
    if (!isNaN(parseFloat(va)) && !isNaN(parseFloat(vb))) {
      va = parseFloat(va); vb = parseFloat(vb);
    } else { va = String(va).toLowerCase(); vb = String(vb).toLowerCase(); }
    return dir === 'asc' ? (va > vb ? 1 : va < vb ? -1 : 0) : (va < vb ? 1 : va > vb ? -1 : 0);
  });
}

function SortTh({ col, label, align, sortCol, sortDir, onSort }) {
  const active = sortCol === col;
  return (
    <th onClick={() => onSort(col)} style={{
      padding:'8px 10px', background:'#f1f5f9', borderBottom:'2px solid #e5e7eb',
      fontSize:11, fontWeight:600, whiteSpace:'nowrap', textAlign:align||'left',
      cursor:'pointer', userSelect:'none',
    }}>
      {label}{' '}<span style={{color:active?'#b30000':'#ccc',fontSize:10}}>
        {active ? (sortDir==='asc' ? '▲' : '▼') : '⇅'}
      </span>
    </th>
  );
}

function useSortState(defaultCol, defaultDir) {
  const [sortCol, setSortCol] = React.useState(defaultCol || 'date');
  const [sortDir, setSortDir] = React.useState(defaultDir || 'desc');
  const onSort = React.useCallback((col) => {
    setSortCol(prev => {
      if (prev === col) { setSortDir(d => d === 'asc' ? 'desc' : 'asc'); return prev; }
      setSortDir('desc');
      return col;
    });
  }, []);
  return { sortCol, sortDir, onSort };
}


const eur = n => '€ ' + parseFloat(n||0).toLocaleString('it-IT',{minimumFractionDigits:2});
const fmtData = d => d ? d.substring(0,10).split('-').reverse().join('/') : '—';



// ── Ordinamento colonne ────────────────────────────────────────
export default function PreventiviPage() {
  const [vista, setVista]   = useState('lista');
  const [prevSel, setPrev]  = useState(null);

  if (vista==='nuovo')     return <NuovoPreventivo onBack={()=>setVista('lista')} onSaved={()=>setVista('lista')} />;
  if (vista==='modifica')  return <NuovoPreventivo modificaPrev={prevSel} onBack={()=>setVista('dettaglio')} onSaved={()=>setVista('lista')} />;
  if (vista==='dettaglio') return <DettaglioPreventivo prev={prevSel} onBack={()=>setVista('lista')} onModifica={()=>setVista('modifica')} />;
  return <ListaPreventivi 
    onNuovo={()=>setVista('nuovo')}
    onApri={p=>{setPrev(p);setVista('dettaglio');}}
  />;
}


// ── DETTAGLIO PREVENTIVO ──────────────────────────────────────
function DettaglioPreventivo({ prev, onBack, onModifica }) {
  const [dettaglio, setDettaglio] = React.useState(null);
  const [loading, setLoading]    = React.useState(true);
  const [stato, setStato]        = React.useState('in_attesa');
  const [mailInviata, setMailInviata] = React.useState(false);
  const [dataMail, setDataMail]  = React.useState(null);
  const [salvandoStato, setSalvandoStato] = React.useState(false);

  React.useEffect(() => {
    if (!prev) return;
    fetch(`${getApiBase()}/api/fic/preventivo/${prev.id}`, {
      headers: { 'Authorization': 'Bearer ' + localStorage.getItem('quindi_token') }
    }).then(r => r.json())
      .then(d => setDettaglio(d.data || prev))
      .catch(() => setDettaglio(prev))
      .finally(() => setLoading(false));
    // Carica stato accettato/rifiutato
    api.get(`/preventivo-stato/${prev.id}`)
      .then(r => { const s = r.data?.data || {};
                   setStato(s.stato || 'in_attesa');
                   setMailInviata(!!s.mail_inviata);
                   setDataMail(s.data_mail || null); })
      .catch(() => {});
  }, [prev]);

  const [bozzaLoad, setBozzaLoad] = React.useState(false);

  const segnaMail = async (val) => {
    try {
      await api.post(`/preventivo-mail/${prev.id}`, { inviata: val });
      setMailInviata(val);
      setDataMail(val ? new Date().toLocaleDateString('it-IT') : null);
    } catch(e) { alert('Errore: ' + e.message); }
  };

  const preparaBozza = async () => {

    setBozzaLoad(true);

    try {

      const r = await api.post(`/preventivi/${prev.id}/bozza-email`, {});
      setMailInviata(true);
      setDataMail(new Date().toLocaleDateString('it-IT'));

      alert(`✅ Bozza creata nella cartella Bozze.\nDestinatario: ${r.data?.destinatario}` +

            (r.data?.allegato ? '\nPreventivo allegato.' : '\n⚠️ PDF non allegato.'));

    } catch(e) { alert('Errore: ' + (e.response?.data?.error || e.message)); }

    finally { setBozzaLoad(false); }

  };


  const eliminaPreventivo = async () => {
    if (!window.confirm(`Eliminare il preventivo N° ${dettaglio?.number || prev.number}? L'operazione è irreversibile e rimuove il preventivo anche da Fatture in Cloud.`)) return;
    try {
      await api.delete(`/fic/preventivo/${prev.id}`);
      alert('Preventivo eliminato.');
      onBack();
    } catch(e) { alert('Errore: ' + (e.response?.data?.error || e.message)); }
  };

  const cambiaStato = async (nuovoStato) => {
    setSalvandoStato(true);
    try {
      await api.post(`/preventivo-stato/${prev.id}`, { stato: nuovoStato });
      setStato(nuovoStato);
    } catch(e) { alert('Errore: ' + (e.response?.data?.error || e.message)); }
    finally { setSalvandoStato(false); }
  };

  if (!prev) return null;
  if (loading) return <div className="loading"><div className="spinner"></div></div>;

  const p2 = dettaglio || prev;
  const fmtData = d => d ? d.substring(0,10).split('-').reverse().join('/') : '—';
  const eur = n => '€ ' + parseFloat(n||0).toLocaleString('it-IT',{minimumFractionDigits:2});
  const scaduto = p2.expiry_date && new Date(p2.expiry_date) < new Date();

  return (
    <div className="page-content">
      <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:16,flexWrap:'wrap'}}>
        <button className="btn btn-secondary" onClick={onBack}>⬅ Preventivi</button>
        <h2 style={{margin:0}}>Preventivo N° {p2.number}</h2>
        {scaduto && <span className="badge badge-red">⚠️ Scaduto</span>}
        <div style={{marginLeft:'auto',display:'flex',gap:6}}>
          {(p2.url || p2.attachment_url) && (
            <a href={p2.url || p2.attachment_url} target="_blank" rel="noopener noreferrer"
               className="btn btn-secondary btn-sm">
              🖨️ PDF
            </a>
          )}
          <button className="btn btn-secondary btn-sm" onClick={onModifica}>
            ✏️ Modifica
          </button>
          <button className="btn btn-secondary btn-sm" onClick={preparaBozza} disabled={bozzaLoad}>{bozzaLoad ? '...' : '📧 Prepara bozza email'}</button>
            <button className="btn btn-danger btn-sm" onClick={eliminaPreventivo}>
            🗑 Elimina
          </button>
        </div>
      </div>

      {/* STATO ACCETTAZIONE */}
      <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:16,padding:'12px 16px',background:'#f9fafb',borderRadius:8,border:'1px solid #e5e7eb',flexWrap:'wrap'}}>
        <span style={{fontSize:13,fontWeight:600,color:'#374151'}}>Stato preventivo:</span>
        {stato==='accettato' && <span className="badge badge-green" style={{fontSize:12}}>✅ Accettato</span>}
        {stato==='rifiutato' && <span className="badge badge-red" style={{fontSize:12}}>❌ Rifiutato</span>}
        {stato==='in_attesa' && <span className="badge badge-gray" style={{fontSize:12}}>⏳ In attesa</span>}
        <span onClick={()=>segnaMail(!mailInviata)} title="Clicca per cambiare"
          className="badge" style={{fontSize:12, cursor:'pointer',
            background: mailInviata ? '#dbeafe' : '#f1f5f9',
            color: mailInviata ? '#1d4ed8' : '#94a3b8'}}>
          {mailInviata ? `📨 Mail inviata${dataMail ? ' il '+dataMail : ''}` : '✉️ Mail da inviare'}
        </span>
        <div style={{marginLeft:'auto',display:'flex',gap:6}}>
          <button className="btn btn-sm" disabled={salvandoStato||stato==='accettato'}
            onClick={()=>cambiaStato('accettato')}
            style={{background:stato==='accettato'?'#16a34a':'#dcfce7',color:stato==='accettato'?'#fff':'#16a34a',border:'none'}}>
            ✅ Accetta
          </button>
          <button className="btn btn-sm" disabled={salvandoStato||stato==='rifiutato'}
            onClick={()=>cambiaStato('rifiutato')}
            style={{background:stato==='rifiutato'?'#dc2626':'#fee2e2',color:stato==='rifiutato'?'#fff':'#dc2626',border:'none'}}>
            ❌ Rifiuta
          </button>
          {stato!=='in_attesa' && (
            <button className="btn btn-secondary btn-sm" disabled={salvandoStato}
              onClick={()=>cambiaStato('in_attesa')}>
              ↩️ Reimposta
            </button>
          )}
        </div>
      </div>

      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16,maxWidth:800}}>

        {/* INFO */}
        <div className="card">
          <div className="card-title" style={{marginBottom:12}}>📋 Dettagli</div>
          <table style={{width:'100%',fontSize:13}}>
            <tbody>
              {[
                ['Cliente',  p2.entity?.name],
                ['Data',     fmtData(p2.date)],
                ['Scadenza', fmtData(p2.expiry_date)],
                ['Modalità pagamento', p2.payment_method?.name || '—'],
                ['Oggetto',  p2.subject],
                ['Note',     p2.notes],
              ].filter(([,v])=>v).map(([k,v])=>(
                <tr key={k}>
                  <td style={{color:'#9ca3af',padding:'4px 0',width:'35%'}}>{k}</td>
                  <td style={{color: k==='Scadenza'&&scaduto?'#dc3545':'inherit'}}>{v}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* TOTALI */}
        <div className="card">
          <div className="card-title" style={{marginBottom:12}}>💰 Importi</div>
          <table style={{width:'100%',fontSize:13}}>
            <tbody>
              <tr><td style={{color:'#9ca3af',padding:'4px 0'}}>Imponibile</td>
                  <td style={{textAlign:'right'}}>{eur(p2.amount_net)}</td></tr>
              <tr><td style={{color:'#9ca3af',padding:'4px 0'}}>IVA</td>
                  <td style={{textAlign:'right'}}>{eur((p2.amount_gross||0)-(p2.amount_net||0))}</td></tr>
              <tr style={{borderTop:'2px solid #e5e7eb'}}>
                  <td style={{padding:'8px 0',fontWeight:700}}>Totale</td>
                  <td style={{textAlign:'right',fontWeight:700,color:'#b30000',fontSize:16}}>{eur(p2.amount_gross)}</td></tr>
            </tbody>
          </table>
        </div>

        {/* RIGHE */}
        {p2.items_list?.length > 0 && (
          <div className="card" style={{gridColumn:'1/-1',padding:0}}>
            <div style={{padding:'12px 16px',fontWeight:600,fontSize:13,borderBottom:'1px solid #e5e7eb'}}>🔧 Voci</div>
            <div className="table-wrap">
              <table className="q-table">
                <thead><tr>
                  <th>Descrizione</th><th style={{textAlign:'center'}}>Qtà</th>
                  <th style={{textAlign:'right'}}>Prezzo netto</th>
                  <th style={{textAlign:'center'}}>IVA</th>
                  <th style={{textAlign:'right'}}>Totale</th>
                </tr></thead>
                <tbody>
                  {p2.items_list.map((item,i)=>(
                    <tr key={i}>
                      <td>{item.name}</td>
                      <td style={{textAlign:'center'}}>{item.qty}</td>
                      <td style={{textAlign:'right'}}>{eur(item.net_price)}</td>
                      <td style={{textAlign:'center',fontSize:11,color:'#6b7280'}}>{item.vat?.value||22}%</td>
                      <td style={{textAlign:'right',fontWeight:600}}>{eur(parseFloat(item.qty||1)*parseFloat(item.net_price||0))}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ── LISTA ──────────────────────────────────────────────────────
function ListaPreventivi({ onNuovo, onApri }) {
  const stampaPreventivo = async (id) => {
    const w = window.open('', '_blank');   // aperta subito: dopo l'await la bloccherebbe il browser
    try {
      const r = await api.get(`/fic/preventivo/${id}`);
      const url = r.data?.data?.url || r.data?.data?.attachment_url;
      if (!url) { w.close(); window.alert('PDF non disponibile per questo preventivo.'); return; }
      w.location = url;
    } catch (e) {
      w.close(); window.alert('Errore: ' + (e.message || e));
    }
  };
  const [preventivi, setPreventivi] = useState([]);
  const { sortCol, sortDir, onSort } = useSortState('date', 'desc');
  const prevSorted = React.useMemo(() => sortData(preventivi, sortCol, sortDir), [preventivi, sortCol, sortDir]);
  const [loading, setLoading]       = useState(true);
  const [pagina, setPagina]         = useState(1);
  const [totPagine, setTotPag]      = useState(1);
  const [q, setQ]                   = useState('');

  const [stati, setStati] = useState({});

  const PER_PAGINA = 50;

  const carica = async () => {
    setLoading(true);
    try {
      const res = await ficApi.preventivi(1);
      setPreventivi(res.data?.data || []);
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  };

  useEffect(() => { carica(); }, []);

  // Carica stati accettato/rifiutato
  useEffect(() => {
    api.get('/preventivi-stati').then(r => {
      const map = {};
      (r.data?.data || []).forEach(s => { map[s.fic_id] = s; });
      setStati(map);
    }).catch(()=>{});
  }, [preventivi]);

  React.useEffect(() => { setPagina(1); }, [q, sortCol, sortDir]);

  const filtrati = prevSorted.filter(p =>
    !q || p.entity?.name?.toLowerCase().includes(q.toLowerCase()) ||
           String(p.number).includes(q) ||
           (p.subject||'').toLowerCase().includes(q.toLowerCase())
  );

  const totPag = Math.max(1, Math.ceil(filtrati.length / PER_PAGINA));
  const visibili = filtrati.slice((pagina-1)*PER_PAGINA, pagina*PER_PAGINA);

  return (
    <div className="page-content">
      <div style={{display:'flex',gap:12,marginBottom:16,flexWrap:'wrap'}}>
        <input className="form-control" style={{maxWidth:260}}
          placeholder="🔍 Cliente, numero o oggetto..."
          value={q} onChange={e=>setQ(e.target.value)} />
        <button className="btn btn-primary" onClick={onNuovo}>➕ Nuovo preventivo</button>
        <span style={{marginLeft:'auto',alignSelf:'center',color:'#9ca3af',fontSize:13}}>
          {filtrati.length} preventivi · pag. {pagina}/{totPag}
        </span>
      </div>

      {loading ? <div className="loading"><div className="spinner"></div></div> : (
        <div className="card" style={{padding:0}}>
          <div className="table-wrap">
            <table className="q-table">
              <thead><tr>
                <SortTh col='number' label='N°' align='left' sortCol={sortCol} sortDir={sortDir} onSort={onSort} /><SortTh col='date' label='Data' align='left' sortCol={sortCol} sortDir={sortDir} onSort={onSort} /><SortTh col='entity_name' label='Cliente' align='left' sortCol={sortCol} sortDir={sortDir} onSort={onSort} /><th>Oggetto</th>
                <th style={{textAlign:'right'}}>Totale</th><th style={{padding:'8px 10px',background:'#f1f5f9',borderBottom:'2px solid #e5e7eb',fontSize:11,fontWeight:600,textAlign:'left'}}>Scadenza</th><th style={{padding:'8px 10px',background:'#f1f5f9',borderBottom:'2px solid #e5e7eb',fontSize:11,fontWeight:600,textAlign:'center'}}>Stato</th><th></th>
              </tr></thead>
              <tbody>
                {visibili.length===0 && (
                  <tr><td colSpan={8} style={{textAlign:'center',color:'#9ca3af',padding:32}}>Nessun preventivo</td></tr>
                )}
                {visibili.map(p => {
                  const scaduto = p.expiry_date && new Date(p.expiry_date) < new Date();
                  return (
                    <tr key={p.id} style={{background:scaduto?'#fff5f5':undefined, cursor:'pointer'}}
                      onClick={()=>onApri && onApri(p)}>
                      <td><strong>{p.number}</strong></td>
                      <td style={{fontSize:12}}>{fmtData(p.date)}</td>
                      <td><strong>{p.entity?.name||'—'}</strong></td>
                      <td style={{fontSize:12,color:'#6b7280',maxWidth:200,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{p.subject||'—'}</td>
                      <td style={{textAlign:'right',fontWeight:600}}>{eur(p.amount_gross)}</td>
                      <td style={{fontSize:12,color:scaduto?'#dc3545':'#6b7280'}}>{fmtData(p.expiry_date)}</td>
                      <td style={{textAlign:'center'}}>
                        {stati[p.id]?.stato==='accettato' && <span className="badge badge-green" style={{fontSize:10}}>✅ Accettato</span>}
                        {stati[p.id]?.stato==='rifiutato' && <span className="badge badge-red" style={{fontSize:10}}>❌ Rifiutato</span>}
                        {(!stati[p.id]||stati[p.id]?.stato==='in_attesa') && <span className="badge badge-gray" style={{fontSize:10}}>⏳ In attesa</span>}
                        {stati[p.id]?.mail_inviata
                          ? <span className="badge" style={{fontSize:10, background:'#dbeafe', color:'#1d4ed8', marginLeft:4}}
                              title={stati[p.id]?.data_mail ? 'Inviata il '+stati[p.id].data_mail : ''}>📨 Mail</span>
                          : <span className="badge" style={{fontSize:10, background:'#f8fafc', color:'#cbd5e1', marginLeft:4}}>✉️</span>}
                      </td>
                      <td style={{display:'flex',gap:4}} onClick={e=>e.stopPropagation()}>
                        <button className="btn btn-secondary btn-sm"
                          onClick={()=>stampaPreventivo(p.id)}>🖨️ PDF</button>
                        <button className="btn btn-secondary btn-sm" onClick={()=>onApri && onApri(p)}>Apri →</button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {totPag>1 && (
        <div style={{display:'flex',gap:8,marginTop:12,justifyContent:'center'}}>
          <button className="btn btn-secondary btn-sm" disabled={pagina<=1} onClick={()=>setPagina(pagina-1)}>⬅</button>
          <span style={{alignSelf:'center',fontSize:13}}>{pagina}/{totPag}</span>
          <button className="btn btn-secondary btn-sm" disabled={pagina>=totPag} onClick={()=>setPagina(pagina+1)}>➡</button>
        </div>
      )}
    </div>
  );
}

// ── NUOVO PREVENTIVO ──────────────────────────────────────────
function NuovoPreventivo({ onBack, onSaved, modificaPrev }) {
  const isModifica = !!modificaPrev;
  const [clienti, setClienti]   = useState([]);
  const [prodotti, setProdotti] = useState([]);
  const [cercaC, setCercaC]     = useState('');
  const [clienteSel, setClSel] = useState(null);
  const [form, setForm]         = useState({
    data:     new Date().toISOString().split('T')[0],
    scadenza: '',
    oggetto:  '',
    note:     '',
    metodo_pagamento: '',
  });
  const [righe, setRighe]   = useState([{descrizione:'',quantita:1,prezzo:0,iva:22,sconto:0}]);
  const [saving, setSaving] = useState(false);
  const [error, setError]   = useState('');
  const [cercaP, setCercaP] = useState('');
  const [loadingDett, setLoadingDett] = useState(isModifica);

  useEffect(() => {
    api.get('/preventivi/clienti').then(r => setClienti(r.data?.data || [])).catch(console.error);
    api.get('/preventivi/prodotti').then(r => setProdotti(r.data?.data || [])).catch(console.error);
  }, []);

  // Precompila il form in modalità modifica
  useEffect(() => {
    if (!isModifica) return;
    fetch(`${getApiBase()}/api/fic/preventivo/${modificaPrev.id}`, {
      headers: { 'Authorization': 'Bearer ' + localStorage.getItem('quindi_token') }
    }).then(r => r.json()).then(d => {
      const p = d.data?.data || d.data;
      if (!p) { setLoadingDett(false); return; }
      // Cliente
      if (p.entity) setClSel({ id: p.entity.id, name: p.entity.name });
      // Form
      setForm({
        data:     p.date || new Date().toISOString().split('T')[0],
        scadenza: p.expiry_date || '',
        oggetto:  p.subject || '',
        note:     p.notes || '',
        metodo_pagamento: p.payment_method?.name || '',
      });
      // Righe
      if (Array.isArray(p.items_list) && p.items_list.length > 0) {
        setRighe(p.items_list.map(it => ({
          descrizione: it.name || it.description || '',
          quantita:    it.qty || 1,
          prezzo:      it.net_price || 0,
          iva:         it.vat?.value ?? 22,
          sconto:      it.discount || 0,
          prodotto_id: it.product_id || null,
        })));
      }
      setLoadingDett(false);
    }).catch(() => setLoadingDett(false));
  }, [isModifica, modificaPrev]);

  const clientiFiltrati = clienti.filter(c =>
    !cercaC || c.name?.toLowerCase().includes(cercaC.toLowerCase())
  );

  const prodottiFiltrati = prodotti.filter(p =>
    !cercaP || p.name?.toLowerCase().includes(cercaP.toLowerCase()) ||
               (p.code||'').toLowerCase().includes(cercaP.toLowerCase())
  );

  const aggRiga = () => setRighe(r => [...r, {descrizione:'',quantita:1,prezzo:0,iva:22,sconto:0}]);
  const rimuRiga = i => setRighe(r => r.filter((_,j) => j!==i));
  const setRiga  = (i,k,v) => setRighe(r => r.map((x,j) => j===i ? {...x,[k]:v} : x));

  const applicaProdotto = (i, prod) => {
    setRighe(r => r.map((x,j) => j===i ? {
      ...x,
      prodotto_id: prod.id,
      descrizione: prod.name,
      prezzo:      parseFloat(prod.net_price||0),
      iva:         prod.vat?.value || 22,
    } : x));
    setCercaP('');
  };

  const totImponibile = righe.reduce((s,r) => {
    const base = parseFloat(r.quantita||1) * parseFloat(r.prezzo||0);
    const sconto = base * parseFloat(r.sconto||0) / 100;
    return s + base - sconto;
  }, 0);
  const totIva = righe.reduce((s,r) => {
    const base = parseFloat(r.quantita||1) * parseFloat(r.prezzo||0);
    const sconto = base * parseFloat(r.sconto||0) / 100;
    const imponibile = base - sconto;
    return s + imponibile * parseFloat(r.iva||22) / 100;
  }, 0);

  const salva = async () => {
    if (!clienteSel) { setError('Seleziona un cliente.'); return; }
    setSaving(true); setError('');
    try {
      const payload = {
        cliente_fic_id: clienteSel.id,
        cliente_nome:   clienteSel.name,
        data:           form.data,
        scadenza:       form.scadenza || null,
        oggetto:        form.oggetto,
        note:           form.note,
        metodo_pagamento: form.metodo_pagamento || null,
        righe:          righe.filter(r => r.descrizione.trim()),
      };
      if (isModifica) {
        await api.put(`/fic/preventivo/${modificaPrev.id}`, payload);
      } else {
        await api.post('/fic/preventivi', payload);
      }
      onSaved();
    } catch(e) {
      setError(e.response?.data?.error || 'Errore nel salvataggio su FIC.');
    } finally { setSaving(false); }
  };

  return (
    <div className="page-content">
      <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:16}}>
        <button className="btn btn-secondary" onClick={onBack}>⬅ Indietro</button>
        <h2 style={{margin:0}}>{isModifica ? '✏️ Modifica preventivo' : '➕ Nuovo preventivo'}</h2>
      </div>

      {error && <div className="error-msg" style={{marginBottom:16}}>{error}</div>}

      <div style={{maxWidth:900}}>

        {/* CLIENTE */}
        <div className="card" style={{marginBottom:16}}>
          <div className="card-title" style={{marginBottom:12}}>👥 Cliente</div>
          {clienteSel ? (
            <div style={{display:'flex',alignItems:'center',gap:12}}>
              <strong>{clienteSel.name}</strong>
              <span style={{color:'#6b7280',fontSize:12}}>{clienteSel.address_street||''}</span>
              <button className="btn btn-secondary btn-sm" onClick={()=>{setClSel(null);setCercaC('');}}>✕ Cambia</button>
            </div>
          ) : (
            <div>
              <input className="form-control" placeholder="Cerca cliente FIC..."
                value={cercaC} onChange={e=>setCercaC(e.target.value)}
                style={{marginBottom:8}} />
              {cercaC && (
                <div style={{border:'1px solid #e5e7eb',borderRadius:6,maxHeight:200,overflowY:'auto',background:'#fff'}}>
                  {clientiFiltrati.slice(0,15).map(c=>(
                    <div key={c.id} onClick={()=>{setClSel(c);setCercaC(c.name);}}
                      style={{padding:'8px 12px',cursor:'pointer',borderBottom:'1px solid #f3f4f6',fontSize:13}}
                      onMouseEnter={e=>e.currentTarget.style.background='#f9fafb'}
                      onMouseLeave={e=>e.currentTarget.style.background=''}>
                      <strong>{c.name}</strong>
                      {c.address_street&&<span style={{color:'#9ca3af',marginLeft:6,fontSize:11}}>{c.address_street}</span>}
                    </div>
                  ))}
                  {clientiFiltrati.length===0&&<div style={{padding:12,color:'#9ca3af',fontSize:13}}>Nessun cliente trovato</div>}
                </div>
              )}
            </div>
          )}
        </div>

        {/* DATI PREVENTIVO */}
        <div className="card" style={{marginBottom:16}}>
          <div className="card-title" style={{marginBottom:12}}>📋 Dati preventivo</div>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
            <div className="form-group" style={{margin:0}}>
              <label className="form-label">Data</label>
              <input type="date" className="form-control" value={form.data}
                onChange={e=>setForm(f=>({...f,data:e.target.value}))} />
            </div>
            <div className="form-group" style={{margin:0}}>
              <label className="form-label">Scadenza</label>
              <input type="date" className="form-control" value={form.scadenza}
                onChange={e=>setForm(f=>({...f,scadenza:e.target.value}))} />
            </div>
            <div className="form-group" style={{margin:0}}>
              <label className="form-label">Modalità di pagamento</label>
              <select className="form-control" value={form.metodo_pagamento}
                onChange={e=>setForm(f=>({...f,metodo_pagamento:e.target.value}))}>
                <option value="">— Nessuna —</option>
                <option value="Bonifico bancario">Bonifico bancario</option>
                <option value="Contanti">Contanti</option>
                <option value="Assegno">Assegno</option>
                <option value="Carta di credito">Carta di credito</option>
                <option value="RIBA">RIBA</option>
              </select>
            </div>
            <div className="form-group" style={{margin:0,gridColumn:'1/-1'}}>
              <label className="form-label">Oggetto</label>
              <input className="form-control" value={form.oggetto}
                onChange={e=>setForm(f=>({...f,oggetto:e.target.value}))}
                placeholder="Es. Manutenzione impianti antincendio..." />
            </div>
          </div>
        </div>

        {/* RIGHE */}
        <div className="card" style={{marginBottom:16}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12}}>
            <span className="card-title">🔧 Voci del preventivo</span>
            <button className="btn btn-secondary btn-sm" onClick={aggRiga}>➕ Riga</button>
          </div>

          {/* Ricerca prodotti */}
          <div style={{marginBottom:12}}>
            <input className="form-control" placeholder="🔍 Cerca prodotto dal catalogo FIC..."
              value={cercaP} onChange={e=>setCercaP(e.target.value)}
              style={{marginBottom:4}} />
            {cercaP && (
              <div style={{border:'1px solid #e5e7eb',borderRadius:6,maxHeight:150,overflowY:'auto',background:'#fff',fontSize:12}}>
                {prodottiFiltrati.slice(0,10).map(p=>(
                  <div key={p.id}
                    style={{padding:'6px 12px',cursor:'pointer',borderBottom:'1px solid #f3f4f6',display:'flex',gap:8}}
                    onMouseEnter={e=>e.currentTarget.style.background='#f9fafb'}
                    onMouseLeave={e=>e.currentTarget.style.background=''}
                    onClick={()=>applicaProdotto(righe.length-1, p)}>
                    <span style={{flex:1}}>{p.name}</span>
                    <span style={{color:'#6b7280'}}>{eur(p.net_price)}</span>
                  </div>
                ))}
                {prodottiFiltrati.length===0&&<div style={{padding:8,color:'#9ca3af'}}>Nessun prodotto trovato</div>}
              </div>
            )}
          </div>

          <table style={{width:'100%',borderCollapse:'collapse',fontSize:13}}>
            <thead><tr style={{background:'#f9fafb'}}>
              <th style={{padding:'6px',textAlign:'left'}}>Descrizione</th>
              <th style={{padding:'6px',textAlign:'center',width:60}}>Qtà</th>
              <th style={{padding:'6px',textAlign:'right',width:90}}>Prezzo netto</th>
              <th style={{padding:'6px',textAlign:'center',width:60}}>IVA%</th>
              <th style={{padding:'6px',textAlign:'center',width:60}}>Sconto%</th>
              <th style={{padding:'6px',textAlign:'right',width:90}}>Totale</th>
              <th style={{width:32}}></th>
            </tr></thead>
            <tbody>
              {righe.map((r,i)=>{
                const base = parseFloat(r.quantita||1)*parseFloat(r.prezzo||0);
                const sc   = base*parseFloat(r.sconto||0)/100;
                const tot  = base-sc;
                return (
                  <tr key={i}>
                    <td style={{padding:'3px'}}>
                      <input className="form-control" value={r.descrizione}
                        onChange={e=>setRiga(i,'descrizione',e.target.value)}
                        style={{fontSize:12,padding:'4px 6px'}} />
                    </td>
                    <td style={{padding:'3px'}}>
                      <input type="number" className="form-control" value={r.quantita} min={1}
                        onChange={e=>setRiga(i,'quantita',e.target.value)}
                        style={{fontSize:12,padding:'4px 6px',textAlign:'center'}} />
                    </td>
                    <td style={{padding:'3px'}}>
                      <input type="number" className="form-control" value={r.prezzo} min={0} step={0.01}
                        onChange={e=>setRiga(i,'prezzo',e.target.value)}
                        style={{fontSize:12,padding:'4px 6px',textAlign:'right'}} />
                    </td>
                    <td style={{padding:'3px'}}>
                      <input type="number" className="form-control" value={r.iva} min={0}
                        onChange={e=>setRiga(i,'iva',e.target.value)}
                        style={{fontSize:12,padding:'4px 6px',textAlign:'center'}} />
                    </td>
                    <td style={{padding:'3px'}}>
                      <input type="number" className="form-control" value={r.sconto} min={0} max={100}
                        onChange={e=>setRiga(i,'sconto',e.target.value)}
                        style={{fontSize:12,padding:'4px 6px',textAlign:'center'}} />
                    </td>
                    <td style={{padding:'3px',textAlign:'right',fontWeight:600,fontSize:12}}>{eur(tot)}</td>
                    <td style={{padding:'3px'}}>
                      <button className="btn btn-danger btn-sm" onClick={()=>rimuRiga(i)}>✕</button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={5} style={{padding:'8px 6px',textAlign:'right',color:'#6b7280',fontSize:13}}>Imponibile:</td>
                <td style={{padding:'8px 6px',textAlign:'right',fontWeight:600}}>{eur(totImponibile)}</td>
                <td></td>
              </tr>
              <tr>
                <td colSpan={5} style={{padding:'3px 6px',textAlign:'right',color:'#6b7280',fontSize:13}}>IVA:</td>
                <td style={{padding:'3px 6px',textAlign:'right',fontWeight:600}}>{eur(totIva)}</td>
                <td></td>
              </tr>
              <tr>
                <td colSpan={5} style={{padding:'8px 6px',textAlign:'right',fontWeight:700,borderTop:'2px solid #e5e7eb'}}>Totale:</td>
                <td style={{padding:'8px 6px',textAlign:'right',fontWeight:700,color:'#b30000',fontSize:15,borderTop:'2px solid #e5e7eb'}}>{eur(totImponibile+totIva)}</td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>

        {/* NOTE */}
        <div className="card" style={{marginBottom:16}}>
          <div className="card-title" style={{marginBottom:8}}>📝 Note</div>
          <textarea className="form-control" rows={3} value={form.note}
            onChange={e=>setForm(f=>({...f,note:e.target.value}))}
            placeholder="Note aggiuntive per il cliente..." />
        </div>

        <div style={{display:'flex',gap:8}}>
          <button className="btn btn-primary" onClick={salva} disabled={saving}>
            {saving?'Salvataggio...':(isModifica?'💾 Salva modifiche':'💾 Crea preventivo')}
          </button>
          <button className="btn btn-secondary" onClick={onBack}>Annulla</button>
        </div>
      </div>
    </div>
  );
}
